import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { PostCard } from "@/components/feed/PostCard";
import { RightSidebar } from "@/components/app/RightSidebar";
import { api } from "@/lib/api";

export default function PostPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.getPost(id).then(setPost).catch((e) => setErr(e.message)); }, [id]);
  return (
    <div className="flex">
      <div className="mx-auto w-full max-w-[600px] px-3 py-4 md:px-5" data-testid="post-page">
        <button onClick={() => navigate(-1)} className="mb-3 flex items-center gap-1 text-sm text-am-text2 hover:text-white"><ArrowLeft className="h-4 w-4" /> Back</button>
        {err ? <p className="py-20 text-center text-sm text-am-text2">{err}</p>
          : !post ? <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-am-text3" /></div>
          : <PostCard post={post} onDeleted={() => navigate("/home")} focusCommentId={params.get("c")} />}
      </div>
      <RightSidebar />
    </div>
  );
}
